import Homepage from "./components/Frontpage/homepage";
import MissionPage from "./components/Mission/MissionPage";
import Navbar from "./components/Navbar/NavBar";
import About from "./components/About/AboutPage";

function App() {
    return (
        <>
            <Navbar />
            <Homepage />
            <MissionPage />
            <About />
        </>
    );
}

export default App;
